(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ring-diamond-bridge"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('bl-ring-config');
  if (!config || window.blRingBridgeLoaded) return;
  window.blRingBridgeLoaded = true;
  const {root, currency, text: t} = JSON.parse(config.textContent);
  const key = 'bradlevi-ring-pair-v1';
  const supported = ['round', 'oval', 'emerald'];
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency || 'USD'}).format(value / 100);
  const words = (key, shape) => t[key].replace('__SHAPE__', shape);
  const save = state => sessionStorage.setItem(key, JSON.stringify(state));
  const read = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(key));
      return state && Date.now() - state.created < 7200000 && supported.includes(state.shape) ? state : null;
    } catch { return null; }
  };
  let state = read();
  let busy = false;
  let panel;
  const api = async (path, body) => {
    const response = await fetch(root + path, {credentials:'same-origin', cache:'no-store', ...(body ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart');
    return data;
  };
  const selected = box => {
    const data = JSON.parse(box.querySelector('[data-bl-ring-data]').textContent);
    const info = box.closest('product-info') || box.closest('section') || document;
    const picker = info.querySelector('variant-selects');
    const values = picker ? [...picker.querySelectorAll('fieldset, select')].map(el => el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value) : [];
    const variant = values.length === data.options.length ? data.variants.find(v => v.options.every((value, i) => value === values[i])) : data.variants.find(v => String(v.id) === (new URLSearchParams(location.search).get('variant') || String(data.selected)));
    return {data, variant, shape:variant?.options[data.shapeIndex]?.toLowerCase()};
  };
  const catalogUrl = context => {
    const url = new URL(root + 'pages/diamonds', location.origin);
    url.searchParams.set('shapes', context.shape);
    url.searchParams.set('bl_setting', context.handle);
    url.searchParams.set('bl_variant', context.variant);
    return url;
  };
  const updateLinks = () => document.querySelectorAll('[data-bl-ring-product]').forEach(box => {
    const {data, variant, shape} = selected(box);
    const link = box.querySelector('[data-bl-ring-start]');
    if (!variant) return;
    const compatible = supported.includes(shape);
    link.textContent = compatible ? t.add : t.request;
    link.href = compatible ? catalogUrl({handle:data.handle, variant:variant.id, shape}) : root + 'pages/ring-builder?settingId=' + data.id + '&settingVariantId=' + variant.id;
  });
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) queueMicrotask(updateLinks);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-bl-ring-start]');
    if (!link) return;
    const box = link.closest('[data-bl-ring-product]');
    const {data, variant, shape} = selected(box);
    const error = box.querySelector('[data-bl-ring-error]');
    updateLinks();
    if (!variant || !variant.available) {
      event.preventDefault(); error.textContent = t.unavailable; error.hidden = false; return;
    }
    if (!supported.includes(shape)) return;
    const next = {created:Date.now(), pair:crypto.randomUUID(), handle:data.handle, product:data.id, variant:variant.id, title:data.title, metal:variant.title, price:variant.price, shape};
    try { save(next); state = next; } catch { event.preventDefault(); error.textContent = t.storage; error.hidden = false; }
  }, true);
  updateLinks();
  const inCatalog = location.pathname === root + 'pages/diamonds';
  const inCart = location.pathname === root + 'cart' || location.pathname === root + 'cart/';
  const make = (tag, content, parent, attrs = {}) => {
    const el = document.createElement(tag);
    if (content) el.textContent = content;
    Object.entries(attrs).forEach(([name,value]) => el.setAttribute(name,value));
    parent?.append(el);
    return el;
  };
  const clear = () => { sessionStorage.removeItem(key); state = null; };
  const renderPanel = () => {
    if (panel) return panel;
    panel = make('section', '', null, {class:'bl-ring-panel', 'aria-label':t.title});
    make('h2', t.title, panel);
    make('p', `${state.title} · ${state.metal} · ${money(state.price)}`, panel);
    const main = document.querySelector('main');
    main?.prepend(panel);
    return panel;
  };
  const diamondSelection = button => {
    const card = button.closest('.diamond-proxy-product-card, tr');
    const link = card?.querySelector('a[href*="id="]');
    const url = new URL(link?.href || location.href);
    const title = card?.querySelector('.diamond-proxy-diamond-title')?.textContent || document.querySelector('#diamond-proxy-root h2')?.textContent || '';
    return {id:url.searchParams.get('id'), title:title.trim(), type:url.searchParams.get('stoneType') || 'diamond'};
  };
  const matchesShape = title => new RegExp('\\b' + state.shape + '\\b', 'i').test(title);
  const blockEvent = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  const checkoutGate = enable => {
    document.documentElement.classList.toggle('bl-ring-pending', enable);
    document.querySelectorAll('.cart__footer').forEach(el => el.inert = enable);
  };
  const completeRing = async () => {
    if (busy || !state?.pending || state.done) return;
    busy = true;
    checkoutGate(true);
    const host = renderPanel();
    let status = host.querySelector('[data-bl-ring-status]') || make('p','',host,{'data-bl-ring-status':'','role':'status'});
    status.textContent = t.loading;
    host.querySelector('[data-bl-ring-recovery]')?.remove();
    try {
      let cart = await api('cart.js');
      const diamond = cart.items.find(item => {
        try { return new URL(item.properties?._detail_page_url, location.origin).searchParams.get('id') === state.pending.id; } catch { return false; }
      });
      if (!diamond || diamond.quantity !== 1 || !matchesShape(diamond.product_title || diamond.title)) throw new Error('Diamond selection could not be verified');
      if (diamond.properties?._bl_ring_pair && diamond.properties._bl_ring_pair !== state.pair) throw new Error('Diamond already belongs to another ring');
      const product = await api('products/' + encodeURIComponent(state.handle) + '.js');
      const variant = product.variants.find(v => String(v.id) === String(state.variant));
      const shapeIndex = product.options.findIndex(o => (o.name || o).toLowerCase() === 'shape');
      if (!variant?.available || shapeIndex < 0 || variant.options[shapeIndex].toLowerCase() !== state.shape || String(product.id) !== String(state.product)) throw new Error('Setting unavailable');
      if (!diamond.properties?._bl_ring_pair) {
        cart = await api('cart/change.js', {id:diamond.key, quantity:diamond.quantity, properties:{...diamond.properties, _bl_ring_pair:state.pair, [t.reference]:state.pair.slice(0,8), [t.setting]:`${product.title} — ${variant.title}`}});
      }
      const existing = cart.items.find(item => String(item.variant_id) === String(variant.id) && item.properties?._bl_ring_pair === state.pair);
      if (!existing) {
        await api('cart/add.js', {items:[{id:variant.id, quantity:1, properties:{_bl_ring_pair:state.pair, [t.reference]:state.pair.slice(0,8), [t.diamond]:diamond.product_title || diamond.title, 'Personalization':t.details}}]});
      }
      cart = await api('cart.js');
      if (!cart.items.some(item => String(item.variant_id) === String(variant.id) && item.properties?._bl_ring_pair === state.pair)) throw new Error('Setting not confirmed');
      state.done = true;
      save(state);
      location.reload();
    } catch (error) {
      status.textContent = t.error;
      status.setAttribute('role','alert');
      const actions = make('div','',host,{class:'bl-ring-actions','data-bl-ring-recovery':''});
      const retry = make('button',t.retry,actions,{type:'button',class:'button'});
      retry.addEventListener('click',completeRing);
      const only = make('button',t.only,actions,{type:'button',class:'button button--secondary'});
      only.addEventListener('click',async () => {
        only.disabled = true;
        try {
          const cart = await api('cart.js');
          const setting = cart.items.find(i => String(i.variant_id) === String(state.variant) && i.properties?._bl_ring_pair === state.pair);
          if (setting) await api('cart/change.js',{id:setting.key,quantity:0});
          const diamond = cart.items.find(i => i.properties?._bl_ring_pair === state.pair && String(i.variant_id) !== String(state.variant));
          if (diamond) {
            const properties = {...diamond.properties};
            delete properties._bl_ring_pair; delete properties[t.reference]; delete properties[t.setting];
            await api('cart/change.js',{id:diamond.key,quantity:diamond.quantity,properties});
          }
          clear(); location.reload();
        } catch { only.disabled = false; }
      });
    } finally { busy = false; }
  };
  const boot = async () => {
    if (inCatalog) {
      const params = new URLSearchParams(location.search);
      const handle = params.get('bl_setting');
      const variantId = params.get('bl_variant');
      if (handle && variantId && (!state || state.handle !== handle || String(state.variant) !== variantId || state.done)) {
        try {
          const product = await api('products/' + encodeURIComponent(handle) + '.js');
          const variant = product.variants.find(v => String(v.id) === variantId);
          const index = product.options.findIndex(o => (o.name || o).toLowerCase() === 'shape');
          const shape = variant?.options[index]?.toLowerCase();
          if (!variant?.available || !supported.includes(shape)) return;
          state = {created:Date.now(),pair:crypto.randomUUID(),handle,product:product.id,variant:variant.id,title:product.title,metal:variant.title,price:variant.price,shape};
          save(state);
        } catch { return; }
      }
      if (!state || state.done) return;
      const host = renderPanel();
      make('p',words('choose',state.shape),host);
      const status = make('p','',host,{role:'alert'});
      const actions = make('div','',host,{class:'bl-ring-actions'});
      make('a',t.change,actions,{href:root+'products/'+state.handle+'?variant='+state.variant});
      make('a',t.filter,actions,{href:catalogUrl(state).href});
      const loose = make('button',t.loose,actions,{type:'button',class:'button button--secondary'});
      loose.addEventListener('click',() => {clear(); location.href = root+'pages/diamonds';});
      document.documentElement.classList.add('bl-ring-matching');
      document.addEventListener('click',event => {
        const button = event.target.closest('.diamond-proxy-add-to-cart');
        if (!button || !state || state.done) return;
        const diamond = diamondSelection(button);
        if (!diamond.id || diamond.type !== 'diamond' || !matchesShape(diamond.title)) {
          blockEvent(event); status.textContent = words('mismatch',state.shape); host.scrollIntoView({behavior:'smooth',block:'start'}); return;
        }
        try {state.pending = diamond; save(state);} catch {blockEvent(event); status.textContent = t.storage;}
      },true);
      let scheduled;
      const guard = () => {
        clearTimeout(scheduled);
        scheduled = setTimeout(() => {
          const url = new URL(location.href);
          if (!url.searchParams.has('id') && url.searchParams.get('shapes') !== state.shape) {
            url.searchParams.set('shapes',state.shape);
            location.replace(url.href);
          }
        },250);
      };
      new MutationObserver(guard).observe(document.getElementById('diamond-proxy-root') || document.querySelector('main'),{childList:true,subtree:true});
      guard();
    }
    if (inCart && state?.pending) {
      if (state.done) {
        const cart = await api('cart.js');
        const pair = cart.items.filter(i => i.properties?._bl_ring_pair === state.pair);
        if (pair.length === 2) make('p',t.ready,renderPanel(),{role:'status'});
        return;
      }
      document.addEventListener('click',event => {
        if (state?.pending && !state.done && event.target.closest('[name="checkout"],a[href*="/checkout"]')) blockEvent(event);
      },true);
      document.addEventListener('submit',event => {if(state?.pending && !state.done && event.target.action?.includes('/cart')) blockEvent(event);},true);
      await completeRing();
    }
  };
  boot().catch(() => {});
})();
  } catch(e) { console.error(e); }
})();

})();
